import { render } from "./inventoryManage.vue?vue&type=template&id=03beb7de&scoped=true"
import script from "./inventoryManage.vue?vue&type=script&lang=js"
export * from "./inventoryManage.vue?vue&type=script&lang=js"

import "./inventoryManage.vue?vue&type=style&index=0&id=03beb7de&scoped=true&lang=scss"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03beb7de"]])

export default __exports__